import { svg } from "lit";
const icon = svg `<path d="M5.25 16.75H9.74995V15.25H5.25V16.75ZM14.55 14.6442L19.1442 10.05L18.075 8.98078L14.55 12.5308L13.125 11.1058L12.0808 12.175L14.55 14.6442ZM5.25 12.75H9.74995V11.25H5.25V12.75ZM5.25 8.74995H9.74995V7.25H5.25V8.74995ZM2.5 20.5V3.5H21.5V20.5H2.5ZM3.99998 19H20V4.99998H3.99998V19Z" fill="currentColor"/>`;
export default icon;
